import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { privateAxios } from "../../api/axios";

interface UsePrinterMachineEnableProps {
  printerMachineId: string;
  onSuccess: () => void;
  onError: (error: any) => void;
}

export const usePrinterMachineEnable = ({ printerMachineId, onSuccess, onError }: UsePrinterMachineEnableProps) => {
  return useMutation<void, AxiosError, void>({
    mutationKey: ['enablePrinterMachine', printerMachineId],
    mutationFn: () =>
      privateAxios.put(`/printer/machines/${printerMachineId}/enable`),
    onSuccess,
    onError,
  });
};